export default {
      id: "sk_logo-usage",
      viewBox: "0 0 61 43",
      url: __webpack_public_path__ + "sprite.svg#sk_logo",
      toString: function () {
        return this.url;
      }
    }